<p-toast></p-toast>

<app-page-shell>
  <app-page-hero
    eyebrow="CRM Contracts"
    title="Contract Document Workspace"
    subtitle="Edit contract sections, preview generated HTML, create draft documents, and record signed agreement evidence.">
    <div nav class="workspace-tabs">
      @for (tab of tabs; track tab.id) {
        <button type="button" [class.active]="activeTab() === tab.id" (click)="setTab(tab.id)">
          <i [class]="tab.icon"></i>
          <span>{{ tab.label }}</span>
        </button>
      }
    </div>
    <div actions>
      <p-button label="Save Sections" icon="fa-solid fa-floppy-disk" severity="secondary" [loading]="saving()" (onClick)="saveSections()"></p-button>
      <p-button label="Generate Draft" icon="fa-solid fa-file-circle-plus" [loading]="reportActions.isPending('generate-draft')" (onClick)="generateDraft()"></p-button>
      <p-button label="Preview PDF" icon="fa-solid fa-file-pdf" severity="help" [loading]="reportActions.isPending('preview-pdf')" (onClick)="previewPdf()"></p-button>
    </div>
  </app-page-hero>

  @if (activeTab() === 'sections') {
    <app-page-form-section icon="fa-solid fa-layer-group" title="Draft Sections" subtitle="Each visible section appears in generated contract previews and PDFs.">
      <div class="section-toolbar">
        <p-button label="Initialize Missing Sections" icon="fa-solid fa-wand-magic-sparkles" severity="secondary" [outlined]="true" (onClick)="initializeSections()"></p-button>
      </div>
      @for (section of sections(); track section.sectionKey) {
        <div class="section-editor">
          <div class="section-meta">
            <p-inputGroup>
              <p-inputGroupAddon><i class="fa-solid fa-heading"></i></p-inputGroupAddon>
              <p-iftaLabel>
                <input pInputText [(ngModel)]="section.sectionTitle" [id]="'title-' + section.sectionKey">
                <label [for]="'title-' + section.sectionKey">Section Title</label>
              </p-iftaLabel>
            </p-inputGroup>
            <p-tag [value]="section.source || 'MANUAL'" severity="info"></p-tag>
          </div>
          <p-editor [(ngModel)]="section.sectionHtml" [style]="{ height: '240px' }"></p-editor>
        </div>
      }
    </app-page-form-section>
  }

  @if (activeTab() === 'preview') {
    <app-page-data-panel title="Generated Preview" subtitle="Resolved contract HTML using the current sections and approved placeholders.">
      <div class="preview-frame" [innerHTML]="preview()?.html"></div>
    </app-page-data-panel>
  }

  @if (activeTab() === 'documents') {
    <app-page-data-panel title="Generated Documents" subtitle="Draft, approved, signed, and PDF-linked generated contract records." [resultText]="documents().length + ' documents'">
      <div actions>
        <p-button label="Create PDF Link" icon="fa-solid fa-link" severity="secondary" [disabled]="!selectedDocument()" (onClick)="createPdfLink()"></p-button>
        <p-button label="Approve Generated Draft" icon="fa-solid fa-check" [disabled]="!selectedDocument()" (onClick)="approveDraft()"></p-button>
      </div>
      <div class="document-controls">
        <p-inputGroup>
          <p-inputGroupAddon><i class="fa-solid fa-file-contract"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <input pInputText id="draftTitle" [(ngModel)]="draftTitle">
            <label for="draftTitle">Draft Title</label>
          </p-iftaLabel>
        </p-inputGroup>
        <p-inputGroup>
          <p-inputGroupAddon><i class="fa-solid fa-file-lines"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-select inputId="templateId" [options]="templates()" optionLabel="title" optionValue="templateId" [(ngModel)]="selectedTemplateId" [showClear]="true" styleClass="w-full"></p-select>
            <label for="templateId">Template</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>
      <p-table [value]="documents()" styleClass="p-datatable-sm p-datatable-gridlines">
        <ng-template pTemplate="header">
          <tr>
            <th>Title</th>
            <th>Status</th>
            <th>Generated</th>
            <th>PDF</th>
            <th style="width: 8rem">Action</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-document>
          <tr [class.selected-row]="selectedDocument()?.documentId === document.documentId">
            <td>{{ document.title }}</td>
            <td><p-tag [value]="document.status || 'DRAFT'" severity="info"></p-tag></td>
            <td>{{ document.generatedAt | date:'medium' }}</td>
            <td><a *ngIf="document.pdfUrl" [href]="document.pdfUrl" target="_blank">Open PDF</a><span *ngIf="!document.pdfUrl">-</span></td>
            <td><p-button label="Select" size="small" severity="secondary" (onClick)="selectDocument(document)"></p-button></td>
          </tr>
        </ng-template>
      </p-table>
    </app-page-data-panel>
  }

  @if (activeTab() === 'signature') {
    <app-page-form-section icon="fa-solid fa-signature" title="Signed Agreement" subtitle="Record the final signed agreement URL without changing revision lifecycle status.">
      <div class="signature-grid">
        <p-inputGroup>
          <p-inputGroupAddon><i class="fa-solid fa-link"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <input pInputText id="signedDocumentUrl" [(ngModel)]="signedDocumentUrl">
            <label for="signedDocumentUrl">Signed Agreement URL</label>
          </p-iftaLabel>
        </p-inputGroup>
        <p-button label="Upload Signed Agreement URL" icon="fa-solid fa-cloud-arrow-up" [disabled]="!selectedDocument() || !signedDocumentUrl" (onClick)="saveSignedUrl()"></p-button>
      </div>
      @if (selectedDocument()) {
        <div class="selected-document">
          <p-tag [value]="selectedDocument()?.status || 'DRAFT'"></p-tag>
          <span>{{ selectedDocument()?.title }}</span>
        </div>
      }
    </app-page-form-section>
  }
</app-page-shell>
